import { PortalConfigurationsDto } from "app/api/endpoints/configurations/types";
import { localStorageUtil } from "app/helpers/utils/localStorageUtil"
import { parseJSONToModel } from "app/helpers/functions/parseJSONToModel";
import { portalConfigsMock } from "mocks/configurations";

export function useProjectInfo(): PortalConfigurationsDto {
    const projectInfo = localStorageUtil().getItem("projectInfo");
    const res = projectInfo ? parseJSONToModel<PortalConfigurationsDto>(projectInfo) : portalConfigsMock;
    return res
}